import Icon from '../Icon'
import {BELL_ICON} from '../../../helpers/icons/bell'

const NotificationButton = () => {
  return (
    <button className="notification-button">
      <span className="dot" />
      <Icon svg={BELL_ICON} size="26px" />
    </button>
  )
}

export default NotificationButton
